import get from 'lodash/get';
import {
	createResource,
	type Match,
	type Query,
	type RouteResource,
} from '@atlassian/react-resource-router';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { getLeadWithBoardsProjectProperty } from './getLeadWithBoardsProjectProperty.tsx';

const getProjectKey = ({ match, query }: { match: Match; query: Query }): string =>
	getProjectKeyId(match, query).projectKey || get(match, 'params.issueKey', '').split('-')[0];

export const leadWithBoardsProjectPropertyResource: RouteResource<boolean> =
	createResource<boolean>({
		type: 'JSM_LEAD_WITH_BOARDS_PROJECT_PROPERTY',
		getKey: getProjectKey,
		getData: async ({ match, query }) => {
			const projectKey = getProjectKey({ match, query });

			if (!projectKey) {
				return false;
			}

			try {
				return await getLeadWithBoardsProjectProperty(projectKey);
			} catch {
				return false;
			}
		},
		maxAge: 5 * 60 * 1000,
	});
